import { ButtonMultiSelectionGroupClass } from '../../../components/button-selection-group-fields/descope-button-multi-selection-group/ButtonMultiSelectionGroupClass';
import { createBaseButtonSelectionGroupMappings } from './baseButtonSelectionGroup';

const vars = ButtonMultiSelectionGroupClass.cssVarList;

const buttonMultiSelectionGroup = {
  ...createBaseButtonSelectionGroupMappings(vars),
};

export default buttonMultiSelectionGroup;
export { vars };
